<template>
  <AdminModal
    :confirm-button-title="`${this.selected ? '수정' : '등록'}`"
    :modal-title="`${this.selected ? '강의 할인 수정' : '강의 할인 등록'}`"
    :is-open="isOpen" 
    :confirm="confirm"
    :close="close"
    modal-size="lg"
    name="lessonProductDiscountModal"
  >
    <div class="py-2 px-2">
      <b-row class="my-2">
        <b-form-group label="상품명" label-cols-sm="3" label-size="sm">
          <b-form-input
            class=" mr-sm-2 md-4"
            placeholder="이름을 입력해주세요."
            v-model="title"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="할인가격" label-cols-sm="3" label-size="sm">
          <b-form-input
            type="number"
            class=" mr-sm-2 md-4"
            placeholder="가격을 입력하세요."
            v-model="discountAmount"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="코드" label-cols-sm="3" label-size="sm">
          <b-form-input
            type="text"
            class=" mr-sm-2 md-4"
            placeholder="코드를 입력하세요."
            v-model="code"
          />
        </b-form-group>
      </b-row>
      <b-row class="my-2">
        <b-form-group label="노출 여부" label-cols-sm="3" label-size="sm">
          <b-form-radio-group
            v-model="publishStatus"
            :options="publishOptions"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          />
        </b-form-group>
      </b-row>
    </div>
  </AdminModal>
</template>

<script>
import api from "@/api/api";
import AdminModal from "@/components/modals/AdminModal.vue";

export default {
  name: "LessonProductDiscountModal",
  components: {AdminModal},
  props: ['isOpen', 'close', 'selected', 'reload'],
  data(){
    return {
      id: null,
      title: '',
      discountAmount: 0,
      publishStatus: "PUBLISHED",
      code: "",
      publishOptions: [
        { item: "PUBLISHED", name: '노출' },
        { item: "UNPUBLISHED", name: '비노출' },
      ],
    }
  },
  mounted() {
    if (this.selected) {
      this.id = this.selected.id
      this.title = this.selected.title
      this.discountAmount = this.selected.discountAmount
      this.publishStatus = this.selected.status
      this.code = this.selected.code
    }
  },
  methods: {
    validate(){
      let errorMessage = ''
      if (this.title.length === 0){
        errorMessage = '상품명을 입력하세요.'
      }
      
      if (this.discountAmount === 0) {
        errorMessage = '할인 가격을 입력하세요.'
      }

      if (this.code.length === 0) {
        errorMessage = '코드를 입력하세요.'
      }
      
      if (errorMessage.length > 0) {
        this.$toast.error(errorMessage,
          {
            position: "top-right",
            duration: 2000
          })
        return false
      } else {
        return true
      }
    },
    update(){
      if(this.validate()) {
        api.productLessonDiscount.update({
          id: this.id,
          code: this.code,
          title: this.title,
          discountAmount: this.discountAmount,
          status: this.publishStatus
        }, () => {
          this.reload()
          this.close()
        }, error => {
          alert(error.message)
        })
      }
    },
    save(){
      if(this.validate()) {
        api.productLessonDiscount.save({
          type: "CODE",
          code: this.code,
          title: this.title,
          discountAmount: this.discountAmount,
          status: this.publishStatus
        }, () => {
          this.reload()
          this.close()
        }, error => {
          alert(error.message)
        })
      }
    },
    confirm() {
      if (this.id) {
        this.update()
      } else {
        this.save()
      }
    }
  },
}
</script>

<style scoped>

</style>